import { createStructuredSelector } from 'reselect';
import {
  selectAvailableBalance,
} from '../../../../../selectors/globalSelectors';
import {
  fetchRAGState,
  selectSelectedCharityEin,
  selectGrantPurposeName,
  selectGrantAmount,
  selectStartDate,
  selectNoOfPayments,
  selectScheduleType,
  selectAllocationType,
  selectGrantRecognition,
} from './RecommendGrantPageSelectors';
import {
  selectLoading,
  selectCharityId,
  selectEnteredDate,
  selectHonorOf,
  selectMemoryOf,
  selectNotifyFirstName,
  selectNotifyLastName,
  selectPublishName,
  selectFrequency,
  selectAllocations,
  selectAllSharesAllPools,
  selectAllShares,
  selectEndDate,
  selectCharityInterest,
  selectPurposeId,
  selectAdditionalComments,
  selectMissionaryName,
  selectEventName,
  selectMissionaryLocation,
  selectPurposeCertification,
  selectStandardLanguage,
  selectThirdParty,
  selectAccountName,
  selectIncludeAdvisorInfo,
  selectGrantTimeline,
  selectFastPass,
} from './ConfirmationPageSelectors';
import { selectStatus } from './ScheduleAllocationSelectors';
import { selectScheduleStatus, selectScheduleId } from './EditGrantSelectors';

export const selectCancel = (state) => {
  const { cancel } = fetchRAGState(state);
  return cancel;
};

export const selectCancelAll = (state) => {
  const { cancelAll } = fetchRAGState(state);
  return cancelAll;
};

const selectCheckIssuedDate = (state) => {
  const { checkIssuedDate } = fetchRAGState(state);
  return checkIssuedDate;
};

const selectCheckNumber = (state) => {
  const { checkNumber } = fetchRAGState(state);
  return checkNumber;
};

const selectPaymentLetterLink = (state) => {
  const { paymentLetterLink } = fetchRAGState(state);
  return paymentLetterLink;
};

const selectIsGrantAgreementPayment = (state) => {
  const { isGrantAgreementPayment } = fetchRAGState(state);
  return isGrantAgreementPayment;
};

const selectGrantAgreementId = (state) => {
  const { grantAgreementId } = fetchRAGState(state);
  return grantAgreementId;
};

const selectCheckClearedDate = (state) => {
  const { checkClearedDate } = fetchRAGState(state);
  return checkClearedDate;
};

const selectCharityName = (state) => {
  const { selectedCharityName } = fetchRAGState(state);
  return selectedCharityName;
};

export const viewGrantDetailDerivedStates = createStructuredSelector({
  loading: selectLoading,
  charityId: selectCharityId,
  charityName: selectCharityName,
  charityEin: selectSelectedCharityEin,
  enteredDate: selectEnteredDate,
  status: selectStatus,
  scheduleStatus: selectScheduleStatus,
  inHonorOfName: selectHonorOf,
  inMemoryOfName: selectMemoryOf,
  purposeName: selectGrantPurposeName,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  publishName: selectPublishName,
  grantAmount: selectGrantAmount,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayments: selectNoOfPayments,
  scheduleType: selectScheduleType,
  amountType: selectAllocationType,
  allSharesAllPools: selectAllSharesAllPools,
  allShares: selectAllShares,
  scheduleIdForSpawns: selectScheduleId,
  endDate: selectEndDate,
  charityInterest: selectCharityInterest,
  purposeId: selectPurposeId,
  additionalComments: selectAdditionalComments,
  missionaryName: selectMissionaryName,
  eventName: selectEventName,
  missionaryLocation: selectMissionaryLocation,
  purposeCertification: selectPurposeCertification,
  standardLanguage: selectStandardLanguage,
  grantRecognition: selectGrantRecognition,
  thirdParty: selectThirdParty,
  accountName: selectAccountName,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  cancelSingleStatus: selectCancel,
  cancelAllStatus: selectCancelAll,
  checkIssuedDate: selectCheckIssuedDate,
  checkNumber: selectCheckNumber,
  paymentLetterLink: selectPaymentLetterLink,
  availableBalance: selectAvailableBalance,
  isGrantAgreementPayment: selectIsGrantAgreementPayment,
  grantTimeline: selectGrantTimeline,
  fastPass: selectFastPass,
  grantAgreementId: selectGrantAgreementId,
  checkClearedDate: selectCheckClearedDate,
});
